import { useQuery } from '@tanstack/react-query'

import HyperSDK from '@/lib/utils/hyper.sdk.utils'
import { HexString } from '../config/wagmi'

export type UseHLClearingHouseStateProps = {
  user: HexString
}

export function useHLClearingHouseState({ user }: UseHLClearingHouseStateProps) {
  return useQuery({
    queryKey: ['hlClearingHouseState', user],
    queryFn: async () => {
      const infoClient = await HyperSDK.info()
      return infoClient.perpetuals.getClearinghouseState(user)
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
  })
}
